import { render, staticRenderFns } from "./AttributeReference.vue?vue&type=template&id=86fe04f4&scoped=true&"
import script from "./AttributeReference.vue?vue&type=script&lang=ts&"
export * from "./AttributeReference.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeReference.vue?vue&type=style&index=0&id=86fe04f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe04f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
